// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Col, SchemaTable } from "@components";
import type { ReferralAction } from "@modules/service/reducer/referrals/types";

type OwnProps = $Exact<{
  data: Array<ReferralAction>,
  schema: Object,
  onChange: (data: Array<ReferralAction>) => void,
  disabled?: boolean,
  addItemButtonText?: string,
  title?: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class AbsenceMonitoringActionsForm extends React.Component<Props> {
  get defaultAction() {
    return [
      {
        id: null,
        action: "",
        isActive: true,
      },
    ];
  }

  get data() {
    return this.props.data && this.props.data.length ? this.props.data : this.defaultAction;
  }

  get schema() {
    return this.props.schema;
  }

  get uiSchema() {
    return {
      "ui:order": ["action", "isActive"],
      action: {
        "ui:title": this.props.t("ACTION"),
        "ui:widget": "text",
        "ui:options": {
          disabled: (item: Object) => !item.isActive,
          required: true,
          editable: true,
          minWidth: "85%",
        },
      },
      isActive: {
        "ui:title": this.props.t("STATUS"),
        "ui:widget": "switch",
        "ui:options": {
          editable: true,
        },
      },
    };
  }

  handleAdd = () => {
    this.props.onChange([...this.data, ...this.defaultAction]);
  };

  handleChange = (data: Array<ReferralAction>) => {
    this.props.onChange([...data]);
  };

  render() {
    return (
      <React.Fragment>
        {this.props.disabled ? null : (
          <div className="d-flex justify-content-between row pl-4 pr-4">
            {this.props.title && <h6>{this.props.t(this.props.title)}</h6>}
            <Button
              materialIcon="add_circle"
              className="link record-table__add-button"
              onClick={this.handleAdd}
            >
              {this.props.addItemButtonText || this.props.t("ADD_ACTION")}
            </Button>
          </div>
        )}
        {this.schema && this.uiSchema ? (
          <SchemaTable
            tableData={this.data}
            schema={this.schema}
            uiSchema={this.uiSchema}
            onChange={this.handleChange}
            disabled={!!this.props.disabled}
            allowDeletes
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default localize()(AbsenceMonitoringActionsForm);
